import React, { useState } from "react";
import BottleSilhouette from "./BottleSilhouette";

/**
 * Public image priority:
 *   1. admin uploaded / approved sourced image (gin.image_url)
 *   2. SVG bottle silhouette placeholder
 *
 * Never hotlinks remote URLs — image_url is always a local /api/files/... path
 * served by the BENO backend. If the network load fails we silently fall back to
 * the silhouette so the layout never breaks.
 */
export default function GinImage({ gin, size = 84, className = "" }) {
  const [errored, setErrored] = useState(false);
  // Canonical bottle slot — matches the SVG silhouette ratio (viewBox 120 × 280)
  // so real photos and placeholders share the same visual height across surfaces.
  const slotWidth = size;
  const slotHeight = size * (280 / 120);
  const hasImage = gin?.image_url && !errored;
  if (!hasImage) {
    return <BottleSilhouette category={gin?.category} size={size} className={className} />;
  }
  const src = gin.image_url.startsWith("http")
    ? gin.image_url
    : `${process.env.REACT_APP_BACKEND_URL}${gin.image_url}`;
  return (
    <div
      style={{ width: slotWidth, height: slotHeight }}
      className={`flex items-end justify-center ${className}`}
      data-testid={`gin-image-slot-${gin.id}`}
    >
      <img
        src={src}
        alt={gin.name || ""}
        onError={() => setErrored(true)}
        loading="lazy"
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
          objectPosition: "center bottom",
        }}
        className="drop-shadow-[0_8px_24px_rgba(0,0,0,0.5)]"
        data-testid={`gin-image-${gin.id}`}
      />
    </div>
  );
}
